export default __webpack_public_path__ + "static/media/madhive-icon.f573b8e2.png";